import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import InternalLayout from '../../../components/InternalLayout';
import Divider from '../../../components/Divider';
import Loading from '../../../components/Loading';
import Typography from '../../../components/Typography';
import CardInput from '../../../components/Card';
import InputWrapper from '../../../components/Input/Default';
import SimpleSelectInput from '../../../components/Input/SimpleSelect';
import styles from '../../../styles/style.module.css';
import { bizConfig } from '../../../utils/bizConfig';
import { getData } from 'utils/token';
import Button from 'components/Button';

const Section = styled.section`
  hr {
    margin: 0;
  }
`;

const Header = styled.header`
  height: 132px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  h1 {
    font-weight: 400;
    width: 100%;
    text-align: left;
  }
`;

const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  & > div {
    width: 49%;
    margin-bottom: 0px; 
  }
`;

const SelectContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  & > div {
    width: 48%;
    margin-right: 2%;
  }

  & > div:last-child {
    margin-right: 0;
  }
`;

function ListaProducaoPage(props) {
    const { match } = props;
    const [producoes, setProducoes] = useState([]);
    const [showLoader, setShowLoader] = useState(true);
    const [acessosUsuario, setAcessosUsuario] = useState(null);
    const [linha, setLinha] = useState();
    const [codigoProduto, setCodigoProduto] = useState();
    const [lote, setLote] = useState();
    const [optionsLinhas, setOptionsLinhas] = useState([]);
    const [optionsClientes, setOptionsClientes] = useState([]);
    const [cliente, setCliente] = useState();
    const status = match?.params?.status;
    const userData = getData();
    const [lotesNaoEncontrados, setLotesNaoEncontrados] = useState(false);


    const inq_linhas = match?.params?.inq_linhas || "";
    const inq_clientes = match?.params?.inq_clientes || "";
    const inq_produtos = match?.params?.inq_produtos || "";
    const inq_lotes = match?.params?.inq_lotes || "";
    useEffect(() => {
        if (!status) return;

        setProducoes([]);
        setLinha(undefined);
        setCliente(undefined);
        setCodigoProduto(undefined);
        setLote(undefined);
        setOptionsLinhas([]);
        setOptionsClientes([]);
        setAcessosUsuario(null);

        ConsultarOptionLinhas();
        ConsultarOptionClientes();
    }, [status]);

    useEffect(() => {
        if (!status) return;

        if (status === 'FI' || status === 'AR' || status === 'CA') {
            setShowLoader(false);
            return;
        }

        ConsultarProducoes();
    }, [status]);

    const limparFiltros = () => {
        setLinha("");
        setCodigoProduto("");
        setLote("");
        setCliente("")
        setLotesNaoEncontrados(false);

        ConsultarOptionLinhas();
        ConsultarOptionClientes();

        if (status === 'FI' || status === 'AR' || status === 'CA') {
            setProducoes([]);
        } else {
            buscarProducoesComFiltrosLimpados();
        }
    }


    const ConsultarProducoes = () => {
        let requestInfo = {
            method: 'GET',
            headers: bizConfig.requestHeaders
        };

        const url = new URL(`${bizConfig.rootApi}/InqProducaoStatus`);
        const params = {
            cad_empresa: bizConfig.cad_empresa,
            cad_filial: bizConfig.cad_filial,
            status: status,
            inq_linhas: inq_linhas,
            inq_clientes: inq_clientes,
            inq_produtos: inq_produtos,
            inq_lotes: inq_lotes
        };

        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null) {
                url.searchParams.append(key, params[key]);
            }
        });

        fetch(url, requestInfo)
            .then(response => {
                if (response.status === 200 || response.status === 400) {
                    return response.json();
                } else {
                    throw new Error(response.text());
                }
            })
            .then(response => {
                setProducoes(response);
                ConsultarAcessosUsuario();
            })
            .catch((error) => {
                console.log('Ocorreu um problema na execução da fetch: ' + error.message);
                setShowLoader(false);
            });
    };

    const ConsultarAcessosUsuario = () => {
        let requestInfo = {
            method: 'GET',
            headers: bizConfig.requestHeaders
        };
        fetch(`${bizConfig.rootApi}/InqAcessosProducao/${bizConfig.cad_empresa}/${bizConfig.cad_filial}/${0}/${userData.usuario}`, requestInfo)
            .then(response => {
                if (response.status === 200 || response.status === 400) {
                    return response.json();
                } else {
                    throw new Error(response.text());
                }
            })
            .then(response => {
                setAcessosUsuario(response);
                setShowLoader(false);
            })
            .catch((error) => {
                console.log('Ocorreu um problema na execução da fetch: ' + error.message);
            });
    }

    const ConsultarOptionLinhas = () => {
        let requestInfo = {
            method: 'POST',
            headers: bizConfig.requestHeaders,
            body: JSON.stringify([
                {
                    "nome": "cad_empresa",
                    "valor": bizConfig.cad_empresa
                },
                {
                    "nome": "cad_filial",
                    "valor": bizConfig.cad_filial
                },
                {
                    "nome": "tipo",
                    "valor": "ddl_inq_linhas"
                }
            ])
        };
        fetch(`${bizConfig.rootApi}/DropDown`, requestInfo)
            .then(response => {
                if (response.status === 200 || response.status === 400) {
                    return response.json();
                } else {
                    throw new Error(response.text());
                }
            })
            .then(response => {
                setOptionsLinhas(response);
            })
            .catch((error) => {
                console.log('Ocorreu um problema na execução da fetch: ' + error.message);
            });
    }

    const ConsultarOptionClientes = () => {
        let requestInfo = {
            method: 'POST',
            headers: bizConfig.requestHeaders,
            body: JSON.stringify([
                {
                    "nome": "cad_empresa",
                    "valor": bizConfig.cad_empresa
                },
                {
                    "nome": "cad_filial",
                    "valor": bizConfig.cad_filial
                },
                {
                    "nome": "tipo",
                    "valor": "ddl_inq_clientes"
                }
            ])
        };
        fetch(`${bizConfig.rootApi}/DropDown`, requestInfo)
            .then(response => {
                if (response.status === 200 || response.status === 400) {
                    return response.json();
                } else {
                    throw new Error(response.text());
                }
            })
            .then(response => {
                setOptionsClientes(response);
            })
            .catch((error) => {
                console.log('Ocorreu um problema na execução da fetch: ' + error.message);
            });
    }

    const buscarProducoesComFiltrosLimpados = () => {
        let requestInfo = {
            method: 'GET',
            headers: bizConfig.requestHeaders
        };

        const url = new URL(`${bizConfig.rootApi}/InqProducaoStatus`);
        const params = {
            cad_empresa: bizConfig.cad_empresa,
            cad_filial: bizConfig.cad_filial,
            status: status,
            inq_linhas: "",
            inq_clientes: "",
            inq_produtos: "",
            inq_lotes: ""
        };

        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null) {
                url.searchParams.append(key, params[key]);
            }
        });

        fetch(url, requestInfo)
            .then(response => {
                if (response.status === 200 || response.status === 400) {
                    return response.json();
                } else {
                    throw new Error(response.text());
                }
            })
            .then(response => {
                setProducoes(response);
            })
            .catch((error) => {
                console.log('Ocorreu um problema na execução da fetch: ' + error.message);
            });
    };

    const buscarProducoes = () => {
        let requestInfo = {
            method: 'GET',
            headers: bizConfig.requestHeaders
        };

        const url = new URL(`${bizConfig.rootApi}/InqProducaoStatus`);
        const params = {
            cad_empresa: bizConfig.cad_empresa,
            cad_filial: bizConfig.cad_filial,
            status: status,
            inq_linhas: linha || inq_linhas,
            inq_clientes: cliente || inq_clientes,
            inq_produtos: codigoProduto || inq_produtos,
            inq_lotes: lote || inq_lotes
        };

        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null) {
                url.searchParams.append(key, params[key]);
            }
        });

        fetch(url, requestInfo)
            .then(response => {
                if (response.status === 200 || response.status === 400) {
                    return response.json();
                } else {
                    throw new Error(response.text());
                }
            })
            .then(response => {
                setLotesNaoEncontrados(response.length == 0);
                setProducoes(response);
            })
            .catch((error) => {
                console.log('Ocorreu um problema na execução da fetch: ' + error.message);
            });
    };

    return (
        <InternalLayout>
            <Loading show={showLoader} size="big" />
            <Section>
                <Header>
                    <Typography variant="h1">Inspeção de qualidade</Typography>
                </Header>
                <Divider variant="dark" />
            </Section>
            <Section>
                <Header style={{ justifyContent: 'space-between' }}>
                    {status === 'IN' && (
                        <>
                            <Typography variant="h3">Linhas de produção em andamento</Typography>
                            {!bizConfig.online && acessosUsuario && acessosUsuario.length > 0 && (acessosUsuario[0].novaProducao === 1) && (
                                <a
                                    className='b-1 p-1'
                                    style={{ cursor: 'pointer' }}
                                    href={'/#/nova-producao'}
                                >
                                    + Nova produção
                                </a>
                            )}
                        </>
                    )}
                    {status === 'FI' && (
                        <>
                            <Typography variant="h3">Linhas de produção finalizadas</Typography>
                        </>
                    )}
                    {status === 'AR' && (
                        <>
                            <Typography variant="h3">Linhas de produção arquivadas</Typography>
                        </>
                    )}
                    {status === 'CA' && (
                        <>
                            <Typography variant="h3">Linhas de produção canceladas</Typography>
                        </>
                    )}
                </Header>
                <InputContainer>
                    <InputWrapper
                        id="codigoProduto"
                        name="codigoProduto"
                        label="Produto"
                        onChange={(e) => setCodigoProduto(e.target.value)}
                        value={codigoProduto || ""}
                    />
                    <InputWrapper
                        id="lote"
                        name="lote"
                        label="Lote"
                        onChange={(e) => setLote(e.target.value)}
                        value={lote || ""}
                    />

                </InputContainer>
                <SelectContainer>
                    <SimpleSelectInput
                        id="linha"
                        name="linha"
                        key={`linha-${status}`}
                        label="Linha"
                        options={[
                            <option key="all" value="">Todas as linhas</option>,
                            ...optionsLinhas.map(item => (
                                <option value={item.codigo} key={item.codigo}>{item.display}</option>
                            ))
                        ]}
                        onChange={(e) => {
                            setLinha(e?.props?.value || "");
                        }}
                        value={<option value={linha || ""}>{
                            linha ? optionsLinhas.find(item => item.codigo === linha)?.display : "Todas as linhas"
                        }</option>}
                    />
                    <SimpleSelectInput
                        id="cliente"
                        key={`cliente-${status}`}
                        name="cliente"
                        label="Cliente"
                        options={[
                            <option key="all" value="">Todos os clientes</option>,
                            ...optionsClientes.map(item => (
                                <option value={item.codigo} key={item.codigo}>{item.display}</option>
                            ))
                        ]}
                        onChange={(e) => {
                            setCliente(e?.props?.value || "");
                        }}
                        value={<option value={cliente || ""}>{
                            cliente ? optionsClientes.find(item => item.codigo === cliente)?.display : "Todos os clientes"
                        }</option>}
                    />
                </SelectContainer>
                <div>
                    <Button label="Buscar" style={{ marginBottom: "42px" }} className='my-0' onClick={buscarProducoes} />
                    <Button label="Limpar filtros" style={{ marginBottom: "42px", marginLeft: "16px" }} theme='dark' className='my-0' onClick={limparFiltros} />
                </div>
                <div className={styles.cardsProducao}>
                    {producoes.length > 0 ? (
                        producoes.map((element, index) => (
                            <CardInput
                                key={`card-${index}`}
                                title={`${element.prd_codigo} - ${element.prd_descricao} - ${element.inq_nome_linha} - Lote: ${element.inq_lote} ${element.inq_unificador_lote ? ' - Unificador de lotes: ' + element.inq_unificador_lote : ''} - ${element.cliente}`}
                                link={`/#/producao/${element.inq_id_producao}/${element.inq_possui_pesagem}/${status}`}
                                linkTitle={'Abrir'} />
                        ))
                    ) : null}

                    {lotesNaoEncontrados &&
                        <div style={{
                            color: "red",
                            textAlign: "left",
                            width: "100%",
                            marginTop: "20px",
                            whiteSpace: "nowrap",
                        }}>Não foram encontrados lotes de produção para o filtro informado.</div>
                    }
                </div>
            </Section>
        </InternalLayout>
    );
}

export default ListaProducaoPage;